import { createContext } from 'react';
import FormsContextContainer from '../contexts/FormsContextContainer';

const FormsContext = createContext<FormsContextContainer>(new FormsContextContainer({ name: 'No Configuration Provided', branding: { name: 'No Configuration Provided' } }));

export default FormsContext;